import BlogCard1 from "components/cards/BlogCard1";
import React, {Component} from "react";
import Page from "../../../project-components/pages/Page.js";

class PlaygroundPage extends Component
{
    render() {
        return (
            <>
                <Page 
                    title="BACKYARD PLAYGROUND"
                    subtitle="หน้าสำหรับการทดสอบชุดคำสั่ง"
                    leftSide={
                        <>
                            ผลลัพธ์
                        </>
                    }
                    rightSide={
                        <>
                            <BlogCard1 />
                        </>
                    }
                />
            </>
        );
    }
}

export default PlaygroundPage;
